import { useState, useEffect } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Stack, Button } from '@mui/material';

/* hooks */

import Input from '../../form/Input';
import Select from '../../form/Select';
import Checkbox from '../../form/Checkbox';
import TextArea from '../../form/TextArea';

function Form({
    token,
    dados,
    setDados,
    empresaId,
    empresaIds,
    parametro,
    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsMenu,
    OptionsOperacao,
    OptionsNatureza,
}) {
    const navigate = useNavigateParams();

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
    }

    async function handleOnBlur(e) {}
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();
        //rotina pera obter o valor mesmo sem o usuario clicar no input
        if (!dados.menuId && document.getElementById('menuId').value !== undefined) {
            dados.menuId = parseInt(document.getElementById('menuId').value);
        }
        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Gestão de SubMenus</h1>
            <div>
                <Select
                    text="Selecione o Menu"
                    name="menuId"
                    options={OptionsMenu}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.menuId || ''}
                    isEnum={false}
                    inputWidth={'170px'}
                />
                <Input
                    text="Sub-Menu"
                    type="text"
                    name="descricao"
                    placeholder="nome do Menu"
                    title="Digite o nome do Menu"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required
                />
                <Input
                    text="Título"
                    type="text"
                    name="title"
                    placeholder="Título"
                    title="Digite o título que aparecerá quando o mouse estiver no submenu"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.title || ''}
                />

                <Input
                    text="URL"
                    type="text"
                    name="url"
                    placeholder="URL"
                    title="Digite a URL"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.url || ''}
                />
                <Input
                    text="Target"
                    type="text"
                    name="target"
                    placeholder="target"
                    title="Digite o target, _self, _blank, _parent, _top"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.target || ''}
                />
                <Input
                    text="Tipo"
                    type="text"
                    name="tipo"
                    placeholder="Tipo"
                    title="Digite o tipo Pagar, Receber ou outro conforme uso no sistema"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.tipo || ''}
                />
                <Select
                    text="Operação"
                    name="operacaoId"
                    options={OptionsOperacao}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.operacaoId || ''}
                    isEnum={false}
                    notOptNull={false}
                    required={false}
                    inputWidth={'170px'}
                />
            </div>
            <div>
                <Input
                    text="Origem"
                    type="text"
                    name="origem"
                    placeholder="Origem"
                    title="Filtro para movimentos com base na origem, exemplo: REQ, NFe, SAT, etc"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.origem || ''}
                />
                <Select
                    name="natureza"
                    title="Criar vínculo com a operação transformação quando existe ambiguidade de transformações"
                    text="Natureza"
                    inputWidth="150px"
                    options={OptionsNatureza}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.natureza}
                    isEnum={true}
                    notOptNull={false}
                />
                <Checkbox
                    title="Quando marcado indica que o menu é apenas para administrador"
                    text="Admin"
                    name="apenasAdmin"
                    handleOnChange={handleChange}
                    value={dados.apenasAdmin}
                    checked={!!dados.apenasAdmin}
                />
                <Checkbox
                    title="Quando marcado indica que o menu é de tabela comum"
                    text="Comun"
                    name="comum"
                    handleOnChange={handleChange}
                    value={dados.comum}
                    checked={!!dados.comum}
                />
                <Checkbox
                    title="Quando marcado o submenu esta ATIVO"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Checkbox
                    title="Quando marcado permitirá INCLUIR"
                    text="Incluir"
                    name="incluir"
                    handleOnChange={handleChange}
                    value={dados.incluir}
                    checked={!!dados.incluir}
                />
                <Checkbox
                    title="Quando marcado permitirá EDITAR"
                    text="Editar"
                    name="editar"
                    handleOnChange={handleChange}
                    value={dados.editar}
                    checked={!!dados.editar}
                />
                <Checkbox
                    title="Quando marcado permitirá IMPRIMIR"
                    text="Imprimir"
                    name="imprimir"
                    handleOnChange={handleChange}
                    value={dados.imprimir}
                    checked={!!dados.imprimir}
                />
                <Checkbox
                    title="Quando marcado permitirá CANCELAR"
                    text="Cancelar"
                    name="cancelar"
                    handleOnChange={handleChange}
                    value={dados.cancelar}
                    checked={!!dados.cancelar}
                />
                <Checkbox
                    title="Quando marcado permitirá EDITAR ITEM nos movimentos"
                    text="Editar Item"
                    name="editarItem"
                    handleOnChange={handleChange}
                    value={dados.editarItem}
                    checked={!!dados.editarItem}
                />
                <Checkbox
                    title="Quando marcado permitirá IMPRIMIR ITEM nos movimentos"
                    text="Imprimir Item"
                    name="imprimirItem"
                    handleOnChange={handleChange}
                    value={dados.imprimirItem}
                    checked={!!dados.imprimirItem}
                />
                <Checkbox
                    title="Quando marcado permitirá CANCELAR ITEM nos movimentos"
                    text="Cancelar Item"
                    name="cancelarItem"
                    handleOnChange={handleChange}
                    value={dados.cancelarItem}
                    checked={!!dados.cancelarItem}
                />
                <Checkbox
                    title="permite ao usuário fazer conferências exemplo: caixas, etc"
                    text="Conferir"
                    name="conferir"
                    handleOnChange={handleChange}
                    value={dados.conferir}
                    checked={!!dados.conferir}
                />
                <Checkbox
                    title="Quando marcado permitirá BAIXAR, funciona apenas no modulo FINANCEIRO"
                    text="Baixar"
                    name="baixar"
                    handleOnChange={handleChange}
                    value={dados.baixar}
                    checked={!!dados.baixar}
                />
                <Checkbox
                    title="Quando marcado permitirá CANCELAR BAIXAR, funciona apenas no modulo FINANCEIRO"
                    text="Cancelar Baixa"
                    name="cancelarBaixa"
                    handleOnChange={handleChange}
                    value={dados.cancelarBaixa}
                    checked={!!dados.cancelarBaixa}
                />
                <Checkbox
                    title="Quando marcado permitirá TRANSFORMAR"
                    text="Transformar"
                    name="transformar"
                    handleOnChange={handleChange}
                    value={dados.transformar}
                    checked={!!dados.transformar}
                />
                <Checkbox
                    title="Quando marcado permitirá reajustar preços dos produtos"
                    text="Reajuste"
                    name="reajustarPreco"
                    handleOnChange={handleChange}
                    value={dados.reajustarPreco}
                    checked={!!dados.reajustarPreco}
                />
                <Checkbox
                    title="Quando marcado permitirá visualizar custos"
                    text="Custos"
                    name="custos"
                    handleOnChange={handleChange}
                    value={dados.custos}
                    checked={!!dados.custos}
                />
                <Checkbox
                    title="Permite cadastrar ou editar usuário"
                    text="Usuário"
                    name="usuario"
                    handleOnChange={handleChange}
                    value={dados.usuario}
                    checked={!!dados.usuario}
                />
            </div>
            <div>
                <TextArea
                    text="Objetivo"
                    type="text"
                    name="objetivo"
                    placeholder="Digite aqui o objetivo do menu para o modulo de homologação"
                    title="Digite o objetivo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.objetivo || ''}
                    textAlign="left"
                    linhas="6"
                    colunas="120"
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}

export default Form;
